module.exports = __webpack_public_path__ + "img/feed-4.d20edc90.jpg";